import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { StyledAlert } from './ErrorSnackbar.styled';

type ErrorSnackbarProps = {
  open: boolean;
  customError: string;
};
const ErrorSnackbar: React.FC<ErrorSnackbarProps> = ({ open, customError }) => {
  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000}>
        <StyledAlert severity="error" variant="filled">
          {customError}
        </StyledAlert>
      </Snackbar>
    </div>
  );
};

export default ErrorSnackbar;
